import { HttpInterceptorFn } from '@angular/common/http';
import { SpinnerService } from '../services/spinner/spinner-service';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';

export const spinnerInterceptor: HttpInterceptorFn = (req, next) => {

  const spinner = inject(SpinnerService);

  const ignoredUrls = [
    '/telemetries/available',
    '/models/dropdown',
    '/mileage-plans/dropdown',
    '/pricing-plans/dropdown',
    '/rides/photos/statistics',
    '/damage-reports/statistics',
  ];

  const shouldSkip = ignoredUrls.some(url =>
    req.url.includes(url)
  );

  if (!shouldSkip) {
    spinner.show();
  }

  return next(req).pipe(
    finalize(() => {
      if (!shouldSkip) {
        spinner.hide();
      }
    })
  );
};
